<template>
  <mobialis-form-with-validation @onValidate="continueForm">
    <Hero>
      {{ $t('message.testDrive.homeAddress.heading') }}
      <img :src="require('@/assets/home-emoji-sm.png')" alt="" width="26" height="27" class="mb-1 ml-1" />
      <template slot="description">{{ $t('message.testDrive.homeAddress.msg') }}</template>
    </Hero>
    <mobialis-text-input-with-validation
      rules="required"
      :label="$t('message.credit.streetAddress')"
      v-model="streetAddress"
      vid="streetaddress"
      data-cy="streetAddress"
    ></mobialis-text-input-with-validation>
    <mobialis-text-input-with-validation
      :label="$t('message.credit.unit#')"
      v-model="unitNumber"
      vid="unitNumber"
      data-cy="unitNumber"
      class="input-width-100"
    ></mobialis-text-input-with-validation>
    <mobialis-text-input-with-validation
      rules="required"
      :label="$t('message.common.city')"
      v-model="city"
      vid="city"
      data-cy="city"
    ></mobialis-text-input-with-validation>
    <mobialis-selection-input-with-validation
      v-if="getThisIsAmerica"
      rules="required"
      :label="$t('message.common.state')"
      v-model="state"
      vid="province"
      :placeHolder="$t('message.common.chooseState')"
      :options="states"
      data-cy="state"
    ></mobialis-selection-input-with-validation>
    <mobialis-selection-input-with-validation
      v-else
      rules="required"
      :label="$t('message.common.province')"
      v-model="province"
      vid="province"
      :placeHolder="$t('message.common.chooseProvince')"
      :options="provinces"
      data-cy="province"
    ></mobialis-selection-input-with-validation>
    <mobialis-text-input-with-validation
      v-if="getThisIsAmerica"
      rules="required|length:5"
      :label="$t('message.common.zipCode')"
      v-model="zipCode"
      vid="zipCode"
      data-cy="zipCode"
      mask-type="zipCode"
      class="input-width-100"
    ></mobialis-text-input-with-validation>
    <mobialis-text-input-with-validation
      v-else
      rules="required|length:6"
      :label="$t('message.common.postalCode')"
      v-model="postalCode"
      vid="postalCode"
      data-cy="postalCode"
      mask-type="postalCode"
      class="input-width-100"
    ></mobialis-text-input-with-validation>
    <mobialis-button data-cy="submitForm2" type="submit" class="mt-4 mb-1">
      {{ $t('message.common.continue') }}
    </mobialis-button>
  </mobialis-form-with-validation>
</template>

<script>
import { mapGetters } from 'vuex';
import Hero from '@/components/test-drive/Hero.vue';
import { stateMixin, provinceMixin } from '@/mixins';
import log from '@/services/log';

export default {
  name: 'HomeAddress',
  components: { Hero },
  mixins: [stateMixin, provinceMixin],
  computed: {
    ...mapGetters('business', ['getThisIsAmerica']),
    streetAddress: {
      get() {
        return this.$store.state.user.streetAddress;
      },
      set(value) {
        this.$store.commit('user/SET_STREET_ADDRESS', value);
      },
    },
    unitNumber: {
      get() {
        return this.$store.state.user.unit;
      },
      set(value) {
        this.$store.commit('user/SET_UNIT', value);
      },
    },
    city: {
      get() {
        return this.$store.state.user.city;
      },
      set(value) {
        this.$store.commit('user/SET_CITY', value);
      },
    },
    state: {
      get() {
        return this.$store.state.user.state;
      },
      set(value) {
        this.$store.commit('user/SET_STATE_CODE', this.getStateCode(value));
        this.$store.commit('user/SET_STATE', value);
      },
    },
    province: {
      get() {
        return this.$store.state.user.province;
      },
      set(value) {
        this.$store.commit('user/SET_PROVINCE_CODE', this.getProvinceCode(value));
        this.$store.commit('user/SET_PROVINCE', value);
      },
    },
    zipCode: {
      get() {
        return this.$store.state.user.zipCode;
      },
      set(value) {
        this.$store.commit('user/SET_ZIP_CODE', value);
      },
    },
    postalCode: {
      get() {
        return this.$store.state.user.postalCode;
      },
      set(value) {
        this.$store.commit('user/SET_POSTAL_CODE', value);
      },
    },
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        await this.$store.dispatch('lead/updateLead');
        this.$router.push({ name: `drive-anything-else-${this.baseRoute}` });
      } catch (err) {
        log('Error in test drive address form - Update Lead', err);
        this.$router.push({ name: `drive-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>
